import { render, staticRenderFns } from "./Pre.vue?vue&type=template&id=70d8f6ab&lang=pug&"
import script from "./Pre.vue?vue&type=script&lang=ts&"
export * from "./Pre.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports